if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          if (mediaToSwitch.querySelector('button') == null) return;
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.init();

        document.querySelectorAll('.scroll-to-customer-images-button').forEach((button) => {
          button.addEventListener('click', () => {

            document.querySelector('.customer_images').scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
              document.querySelector('.customer_images').nextElementSibling.querySelector('button').click();
            }, 1000);

            document.querySelector('#customerMainImagesTemplate').nextElementSibling.scrollIntoView({ behavior: 'smooth' });
          });
        });
      }

      firstSlideActive() {

        const thumbnail = this.elements.thumbnails.querySelector(
          `li:first-child`
        );
        this.setActiveThumbnail(thumbnail);
      }
      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('.thumbnail-list .thumbnail-list__item').forEach((element) => element.classList.remove('scrolled-to'));
        thumbnail.classList.add('scrolled-to');
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        // if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      init() {
        this.container = document.querySelector('[data-desktop-layout="thumbnail_slider"] > .thumbnail-slider > .thumbnail-list');
        this.containerMain = document.querySelector('[data-desktop-layout="thumbnail_slider"] > .slider-mobile-gutter > .product__media-list');
        this.containerModal = document.querySelector('.product-media-modal .product-media-modal__dialog .product-media-modal__content');
        if (this.container != null) {
          this.pullReviewsImages();
        }

        this.firstSlideActive();
      }
      pullReviewsImages() {
        const $this = this;
        let product_handle = window.location.pathname.split('/').pop();
        fetch('https://titancasket.mizu.a2hosted.com/titan-judge-2.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "action": "getReviewsImages",
            "product": product_handle
          })
        })
          .then(r => r.json()) // Handle response as JSON
          .then(images => {
            $this.buildCarousel(images);
          })
      }
      buildCarousel(images) {
        if (images.length < 1) {
          this.showNoImages();
        } else {
          document.querySelector('.customer_images').classList.remove('hidden');
          document.querySelectorAll('.scroll-to-customer-images').forEach((button) => {
            button.classList.add('customer-images-loaded');
          });
          this.showCarousel(images);
        }
      }
      showNoImages() {
      }
      showCarousel(images) {
        // Grab the template from the DOM
        let template = document.querySelector('#customerImagesTemplate').innerHTML;
        let templateMain = document.querySelector('#customerMainImagesTemplate').innerHTML;
        let templateModel = document.querySelector('#customerModalImagesTemplate').innerHTML;

        // Iterate through images
        images.forEach((image, index) => {
          let clone = template;
          clone = clone.replace('thumbnail-src-to-replace', image.urls.small);
          clone = clone.replace(/thumbnail-index-to-replace/g, index);
          this.container.innerHTML += clone;

          if (this.containerMain !== null) {
            clone = templateMain;
            clone = clone.replace(/thumbnail-src-to-replace/g, image.urls.original);
            clone = clone.replace(/thumbnail-index-to-replace/g, index);
            this.containerMain.innerHTML += clone;
          }
          if (this.containerModal !== null) {
            clone = templateModel;
            clone = clone.replace(/thumbnail-src-to-replace/g, image.urls.huge);
            clone = clone.replace(/thumbnail-index-to-replace/g, index);
            this.containerModal.innerHTML += clone;
          }
        });

        this.querySelector('slider-component').reinitiateSlider();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          if (mediaToSwitch.querySelector('button') == null) return;
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        initializeScrollAnimationTrigger(document, true);
      }

    }


  );
}
